import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'dynamicsnav-connector-panel',
    templateUrl: './dynamicsnav.connector.panel.html'
})
export class DynamicsNAVConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Dynamics NAV',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.DynamicsNAVInfo',
            ControlType: DynamicsNAVConnectorPanel,
            Default: {
                AuthScheme: 0
            }
        };
    }
}
